export const getCollections = (state) => {
  return state.collections;
}